<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">CRM REPORTS</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Expiry Report </strong>
              <div class="text-sm text-secondary">
                Unspent topup, bonus and cashback that expired. Time filters on the expiry date.
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Expired
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="searchForm.time_type"
                      :options="times"
                      :canClear="false"
                      @change="timeChange($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Branch
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="searchForm.branch"
                      :options="branches"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="isShowTimeCustom">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    From
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.from_date"
                      :format="format"
                      :max-date="searchForm.to_date || today"
                      autoApply
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12 pt-custtom">
                <div class="row">
                  <div
                    class="col-lg-4 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    To
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.to_date"
                      :format="format"
                      :min-date="searchForm.from_date || undefined"
                      :max-date="today"
                      autoApply
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-1 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Search
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <input
                      class="nosubmit"
                      type="search"
                      id="keyword_search"
                      v-model="searchForm.keyword"
                      name="keyword_search"
                      placeholder="Enter member ID, name, email, mobile ..."
                      @keydown.enter="filterData()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a class="dropdown-item" @click="exportFile('csv')" href="#">Export CSV</a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('xlsx')" href="#">Export Excel</a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('pdf')" href="#">Export PDF</a>
                    </li>
                  </ul>
                </div>
                <div style="margin-left: 3vh;">
                  <material-button
                  class="btn-background btn-sm"
                  @click="filterData()"
                  style="width: 162.52px"
                  >
                    Run
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row ps-3">
              <div class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end">
                Count: {{ totalRecords }}
              </div>
              <div class="col-lg-3 col-md-3 col-3 d-flex justify-content-end">
                <ShowHideColumn
                  :columns="columns"
                  :changeCheckbox="changeCheckbox"
                  :columnCheckedCache="columnChecked"
                  :key="key"
                />
              </div>
            </div>
            <div class="row mt-3 g-2 expiry-summary">
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card">
                  <span class="summary-icon icon-topup material-icons-round">account_balance_wallet</span>
                  <div class="summary-content">
                    <div class="summary-label">Topup Expired (unspent)</div>
                    <div class="summary-value">{{ expirySummary.total_topup }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card">
                  <span class="summary-icon icon-bonus material-icons-round">redeem</span>
                  <div class="summary-content">
                    <div class="summary-label">Bonus Expired (unspent)</div>
                    <div class="summary-value">{{ expirySummary.total_bonus }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card summary-card-total">
                  <span class="summary-icon icon-cashback material-icons-round">savings</span>
                  <div class="summary-content">
                    <div class="summary-label">Cashback Expired (unspent)</div>
                    <div class="summary-value">{{ expirySummary.total_cashback }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              Row No
                            </th>
                            <template v-for="item in headersData" :key="item.field">
                              <th class="text-center font-weight-bolder" v-if="columnShowed.includes(item.field)">
                                <span
                                  :class="[
                                    item.sortBy ? 'wrapper-sortby pointer' : '',
                                    sortBy && sortBy === item.sortBy
                                      ? sortType === 'desc'
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="item.sortBy && handleChangeSortColumn(item.sortBy)"
                                >{{ item.label }}</span>
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="transactions.length">
                          <tr v-for="(value, key) in transactions" :key="key">
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              {{ rowOffset + key + 1 }}
                            </td>
                            <template v-for="item in headersData" :key="item.field">
                              <td
                                class="text-center text-xss"
                                :class="{ 'text-danger': item.expiredFlag && value[item.expiredFlag] }"
                                v-if="columnShowed.includes(item.field)"
                              >
                                {{ value[item.field] }}
                              </td>
                            </template>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td :colspan="columnShowed.length || 1" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/download-expiry-report`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="keyword" :value="searchForm.keyword" />
      <input type="hidden" name="time_type" :value="searchForm.time_type" />
      <input type="hidden" name="from_date" :value="dateFormat(searchForm.from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(searchForm.to_date)" />
      <input type="hidden" name="branch" :value="searchForm.branch" />
      <input type="hidden" name="sortCol" :value="sortBy" />
      <input type="hidden" name="sortType" :value="sortType" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialButton from "@/components/MaterialButton.vue";
import ShowHideColumn from "@/components/ShowHideColumn.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
import $ from "jquery";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";

// V2: columns were renamed / added (expired value, member name) — an old cached list would hide them
const COLUMN_CACHE_KEY = "ExpiryColumnV2";
// keep in sync with ValueExpiryReportPdf::MAX_LINES
const PDF_MAX_ROWS = 2000;

export default {
  name: "expiry-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
    ShowHideColumn,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      pagination: {},
      page: 1,
      key: 0,
      today: new Date(),
      times: [
        { value: 0, label: "All Time" },
        { value: 1, label: "Today" },
        { value: 2, label: "Yesterday" },
        { value: 3, label: "Last 7 days" },
        { value: 4, label: "Last 30 days" },
        { value: 5, label: "This month" },
        { value: 6, label: "Last 3 months" },
        { value: 7, label: "This year" },
        { value: 8, label: "Last year" },
        { value: 9, label: "Custom" },
      ],
      isShowTimeCustom: false,
      action_export: "csv",
      totalRecords: 0,
      columnShowed: [],
      columnChecked: [],
      transactions: [],
      expirySummary: {
        total_topup: "$ 0.00",
        total_bonus: "$ 0.00",
        total_cashback: "$ 0.00",
      },
      branches: [],
      searchForm: {
        // bounded by default: "All Time" reads the merchant's whole earn / top-up history
        time_type: 4,
        from_date: null,
        to_date: null,
        keyword: "",
        branch: 0,
      },
      sortBy: "",
      sortType: "",
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page) || 1;
    }
    const cached = window.localStorage.getItem(COLUMN_CACHE_KEY);
    if (cached) {
      this.columnChecked = cached.split(",");
      this.key = Math.random();
    }
    this.getData();
  },
  computed: {
    rowOffset() {
      const p = this.pagination;
      return p.current_page > 1 ? (p.current_page - 1) * (p.per_page || 0) : 0;
    },
    // sortBy = key of SORT_COL_EXPIRY_REPORT; expiredFlag = row flag that turns the cell red
    headersData() {
      return [
        { label: "Receipt No", field: "receipt_no", sortBy: "receipt_no" },
        { label: "Timestamp", field: "created_at_format", sortBy: "created_at" },
        { label: "Txn Type", field: "transaction_type_text", sortBy: "transaction_type" },
        { label: "Topup", field: "topup_amount_format", sortBy: "topup_amount" },
        { label: "Topup Expiry Date", field: "topup_expiry_date_format", sortBy: "topup_expiry_date", expiredFlag: "topup_expired" },
        { label: "Topup Spent", field: "topup_spend_format", sortBy: "topup_spend" },
        { label: "Topup Expired", field: "topup_expired_value_format", sortBy: "topup_expired_value" },
        { label: "Bonus", field: "bonus_amount_format", sortBy: "bonus_amount" },
        { label: "Bonus Expiry Date", field: "bonus_expiry_date_format", sortBy: "bonus_expiry_date", expiredFlag: "bonus_expired" },
        { label: "Bonus Spent", field: "bonus_spend_format", sortBy: "bonus_spend" },
        { label: "Bonus Expired", field: "bonus_expired_value_format", sortBy: "bonus_expired_value" },
        { label: "Cashback", field: "cashback_amount_format", sortBy: "cashback_amount" },
        { label: "Cashback Expiry Date", field: "cashback_expiry_date_format", sortBy: "cashback_expiry_date", expiredFlag: "cashback_expired" },
        { label: "Cashback Spent", field: "cashback_spend_format", sortBy: "cashback_spend" },
        { label: "Cashback Expired", field: "cashback_expired_value_format", sortBy: "cashback_expired_value" },
        { label: "Member ID", field: "member_id_format", sortBy: "member_id" },
        { label: "Member Name", field: "member_name" },
        { label: "Phone No", field: "phone_number" },
      ];
    },
    columns() {
      return [
        { value: "all", label: "ALL" },
        { value: "row_no", label: "Row No" },
        ...this.headersData.map((h) => ({ value: h.field, label: h.label })),
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },
    exportFile(type = "csv") {
      if (this.columnShowed.length == 0) {
        this.snackbar = "danger";
        this.message = "You must select least 1 column to export file.";
        this.setTimeOutNotification();
        return;
      }
      if (type !== "pdf") {
        this.submitExport(type);
        return;
      }
      // PDF is slow on long tables: count rows for the current filters first
      this.loaderActive = true;
      DashboardReportService.getDataExpiryReport(this.buildDataForm(1)).then(
        (response) => {
          this.loaderActive = false;
          const total = response.data.result.isSuccess ? response.data.data.total : 0;
          if (total > PDF_MAX_ROWS) {
            this.snackbar = "danger";
            this.message = `${total} rows — PDF export is limited to ${PDF_MAX_ROWS}. Use Export Excel or narrow the filters.`;
            this.setTimeOutNotification();
          } else {
            this.submitExport(type);
          }
        },
        () => {
          this.loaderActive = false;
          this.submitExport(type);
        }
      );
    },
    submitExport(type) {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },
    buildDataForm(page) {
      return {
        ...this.searchForm,
        from_date: this.dateFormat(this.searchForm.from_date),
        to_date: this.dateFormat(this.searchForm.to_date),
        page: page,
        sortCol: this.sortBy,
        sortType: this.sortType,
      };
    },
    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed;
      window.localStorage.setItem(COLUMN_CACHE_KEY, columnShowed);
    },
    timeChange($event) {
      this.isShowTimeCustom = $event == 9;
    },

    getData() {
      DashboardReportService.getFilterDataTopupReport().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data.branches;
          } else {
            this.message = response.data.result.message;
          }
        },
        (error) => {
          this.message = error;
        }
      );
      this.getList(this.page);
    },

    filterData() {
      this.getList(1);
    },

    dateFormat(date) {
      return date == null ? null : moment(date).format("YYYY-MM-DD");
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleChangeSortColumn(sortBy) {
      if (this.sortBy === sortBy) {
        this.sortType = this.sortType === "asc" ? "desc" : "asc";
      } else {
        this.sortBy = sortBy;
        this.sortType = "asc";
      }
      if (this.transactions.length) {
        this.getList(this.page);
      }
    },

    getList(page) {
      this.loaderActive = true;
      DashboardReportService.getDataExpiryReport(this.buildDataForm(page)).then(
        (response) => {
          this.loaderActive = false;
          if (!response.data.result.isSuccess) {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            return;
          }
          const data = response.data.data;
          // filters changed under a deep page (e.g. from the URL): fall back to the first page once
          if (data.total > 0 && data.current_page > data.last_page) {
            this.getList(1);
            return;
          }
          this.transactions = data.items;
          this.expirySummary = data.expiry_summary;
          this.pagination = data;
          this.page = data.current_page;
          this.totalRecords = data.total;
          this.$router.push({
            query: Object.assign({}, this.$route.query, { page: this.page }),
          });
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.loaderActive = false;
          this.setTimeOutNotification();
        }
      );
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 175px;
  padding-left: 18px;
  padding-right: 28px;
}

table thead th > span {
  position: relative;
  white-space: nowrap;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

@media only screen and (max-width: 991px) {
  .pt-custtom {
    padding-top: 7px;
  }
}

.expiry-summary .summary-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  padding: 16px;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(20, 45, 82, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.expiry-summary .summary-card:hover {
  box-shadow: 0 10px 26px rgba(20, 45, 82, 0.1);
  transform: translateY(-2px);
}

.expiry-summary .summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
}

.expiry-summary .icon-topup {
  background: linear-gradient(135deg, #e08a3c, #f2b562);
}

.expiry-summary .icon-bonus {
  background: linear-gradient(135deg, #9b5de5, #c084f5);
}

.expiry-summary .icon-cashback {
  background: linear-gradient(135deg, #1f6f78, #38b6a0);
}

.expiry-summary .summary-content {
  min-width: 0;
}

.expiry-summary .summary-card-total {
  background: linear-gradient(135deg, #f3f6ff 0%, #eef7f4 100%);
  border-color: #cfe4e0;
}

.expiry-summary .summary-label {
  font-size: 11px;
  color: #8392ab;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.3;
  min-height: 30px;
}

.expiry-summary .summary-value {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  word-break: break-word;
}
</style>
